import {
    SocialAuthActionsTypes,
    SET_SOCIAL_AUTH,
} from "types/actions/Social.action";

export interface SocialAuthData {
    socialAuthData: object;
}

const initState: SocialAuthData = { socialAuthData: {} };

export default function socialAuthReducer(
    state = initState,
    action: SocialAuthActionsTypes
) {
    switch (action.type) {
        case SET_SOCIAL_AUTH:
            return {
                ...state,
                socialAuthData: action.socialAuthData,
            };
        default:
            return state;
    }
}
